import { render, staticRenderFns } from "./DoQuestion.vue?vue&type=template&id=649a4910&"
import script from "./DoQuestion.vue?vue&type=script&lang=js&"
export * from "./DoQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DoQuestion.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DoQuestion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DoQuestion.vue"
export default component.exports